import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import useOutsideClick from '../../hooks/useOutSideClick';
import Icon from '../Icon/Icon';

import styles from './Select.module.scss';

const cx = classNames.bind(styles);

const Select = ({ label, options, onChange, inputRef, disabled, value, name, errors }) => {
	const selectRef = React.useRef(null);
	const [isOpen, setOpen] = React.useState(false);
	const [selected, setSelected] = React.useState(value);
	useOutsideClick(selectRef, () => {
		setOpen(false);
	});

	return (
		<div className={styles.formField}>
			<label className={styles.label} htmlFor={name}>
				{label}
			</label>
			<div className={styles.selectWrapper} ref={selectRef} onClick={() => disabled ? null : setOpen((prev) => !prev)}>
			
				<button className={cx('selectTrigger', { open: isOpen, isDisabled: disabled, error: errors ? errors[name] :  false })} type='button'>
					<span>{value ? value : 'Bitte wählen...'}</span>
					{disabled ? null : <Icon name='chevron_down' size='24' />}
				</button>

				{!disabled && <ul className={cx('selectOptions', { open: isOpen })}>
					{options.map((item) => (
						<li
							className={cx('selectItem', {
								active: selected ? selected === item.value : false,
							})}
							key={item.value}
							onClick={() => {
								onChange(item.value);
								setSelected(item.value);
							}}>
							<span>{item.label}</span>
						</li>
					))}
				</ul>}
			</div>
		</div>
	);
};

Select.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string,
	name: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		}),
	).isRequired,
	onChange: PropTypes.func.isRequired,
	inputRef: PropTypes.any,
	errors: PropTypes.object,
	disabled: PropTypes.bool,
};

export default Select;
